// extracted by css-extract-rspack-plugin
export default {"tab":"ProcedureCategoryTab__tab--klRVB","inner":"ProcedureCategoryTab__inner--LbZkb","active":"ProcedureCategoryTab__active--xUzHF"};